var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import TreatmentAssignmentResource from "@ane/exp-data/lib/resources/TreatmentAssignmentResource";
import { USER_FIELD } from "@ane/core/lib/constants/QueryString.constants";
import Logger from "@ane/core/lib/services/logging/Logger";
import { ProgressIndicator } from "@ane/ui-components/lib/components/ProgressIndicator";
import { TelemetryEventName } from "@ane/core/lib/services/MSALAuthService/TelemetryEventName";
const bundle = "AuthShell";
const TreatmentAssigmentProvider = ({ children }) => {
  const user = EnvironmentService.getUser();
  const [treatmentsLoaded, setTreatments] = React.useState(false);
  React.useEffect(() => {
    if (user) {
      const getTreatments = () => __async(void 0, null, function* () {
        var _a, _b, _c;
        const userQueryAlias = EnvironmentService.getQueryParam(USER_FIELD);
        const currentUserAlias = !!user ? user.alias : "";
        const alias = !!userQueryAlias ? userQueryAlias : currentUserAlias;
        const workspaceContext = EnvironmentService.getWorkspaceIdOrDefault();
        Logger.trackMetric({
          name: `PLT:Bootstrap:${bundle}:init:getTreatmentAssignment:before`,
          average: performance.now(),
          properties: {
            url: document.location.href
          }
        });
        const operationId = ((_c = (_b = (_a = window["appInsights"]) == null ? void 0 : _a.context) == null ? void 0 : _b.telemetryTrace) == null ? void 0 : _c.traceID) || "";
        Logger.log(TelemetryEventName.Core_TAS_parameters, {
          oid: user.oid,
          alias,
          workspaceContext,
          operationId
        });
        const treatmentVariables = yield TreatmentAssignmentResource.getTreatmentAssignment(
          user.oid || "oidundefined",
          alias,
          workspaceContext,
          operationId,
          Logger
        ).catch((e) => {
          Logger.trackMetric({
            name: `PLT:Bootstrap:${bundle}:init:getTreatmentAssignment:error`,
            average: performance.now(),
            properties: {
              url: document.location.href,
              error: e
            }
          });
          return {};
        });
        Logger.trackMetric({
          name: `PLT:Bootstrap:${bundle}:init:setTreatmentVariables:before`,
          average: performance.now(),
          properties: {
            url: document.location.href
          }
        });
        if (!!treatmentVariables) {
          const { Parameters } = treatmentVariables;
          EnvironmentService.setTreatmentVariables(Parameters);
        }
        if (EnvironmentService.logSetUser()) {
          Logger.log(TelemetryEventName.Core_Set_User, {
            email: user.email,
            oid: user.oid
          });
        }
        setTreatments(true);
      });
      getTreatments();
    }
  }, [user]);
  if (!treatmentsLoaded) {
    return /* @__PURE__ */ jsx(ProgressIndicator, { ariaLabel: "", label: "Loading experience", barHeight: 10 });
  }
  return children != null ? children : null;
};
export {
  TreatmentAssigmentProvider
};
//# sourceMappingURL=TreatmentAssigmentProvider.js.map
